module.exports = __webpack_public_path__ + "img/house.a910b72a.png";